import React from "react";
import { StocksRawExplorerProps } from "./types";
import StocksRawFilters from "./StocksRawFilters";
import StocksRawTable from "./StocksRawTable";
import { ExploreBulkActionsToolbar } from "@/components/explore/ExploreBulkActionsToolbar";

// Extracted logic hook
import { useStocksRawExplorerLogic } from "@/hooks/useStocksRawExplorerLogic";

export function StocksRawExplorer({ 
  initialSearchText = "",
  initialType = "",
  initialExchange = "",
}: StocksRawExplorerProps) {
  
  // === USE EXTRACTED LOGIC HOOK ===
  const {
    // Filter states
    searchText,
    setSearchText,
    selectedType,
    setSelectedType,
    selectedExchange,
    setSelectedExchange,
    debouncedSearchText,
    
    // Count states
    totalCount,
    visibleCount,
    
    // Dialog states
    isPortfolioDialogOpen,
    
    // Bulk selection
    bulkSelectionState,
    bulkSelectionActions,
    
    // Event handlers
    handleCountsUpdate,
    handleFavorite,
    handleAddToWatchlist,
    handleAddToPortfolio,
    handleBulkAddToPortfolio,
    handleBulkFavorite,
    handleBulkExport,
    handlePortfolioDialogClose,
    handlePortfolioSuccess,
    
    // Table callback setter
    setGetSelectedStocksData,
    
    // Computed data
    portfolioFund,
    portfolioFunds
  } = useStocksRawExplorerLogic({
    initialSearchText,
    initialType,
    initialExchange
  });

  return (
    <div className="space-y-4">
      {/* Filters */}
      <StocksRawFilters
        searchText={searchText}
        onSearchChange={setSearchText}
        selectedType={selectedType}
        selectedExchange={selectedExchange}
        onTypeFilterChange={setSelectedType}
        onExchangeFilterChange={setSelectedExchange}
        totalCount={totalCount}
        visibleCount={visibleCount}
      />
      
      {/* Bulk Actions Toolbar */}
      <ExploreBulkActionsToolbar
        selectedCount={bulkSelectionState.selectedCount}
        totalCount={totalCount}
        onClearSelection={bulkSelectionActions.clearSelection}
        onAddToPortfolio={handleBulkAddToPortfolio}
        onFavorite={handleBulkFavorite}
        onExport={handleBulkExport}
      />
      
      {/* Table */}
      <StocksRawTable
        filters={{
          searchText: debouncedSearchText,
          type: selectedType,
          exchange: selectedExchange,
        }}
        onAddToPortfolio={handleAddToPortfolio}
        onFavorite={handleFavorite}
        onAddToWatchlist={handleAddToWatchlist}
        onCountsUpdate={handleCountsUpdate}
        queryEnabled={true}
        bulkSelection={{
          isSelected: bulkSelectionActions.isSelected,
          toggleItem: bulkSelectionActions.toggleItem,
          toggleAll: bulkSelectionActions.toggleAll,
          isAllSelected: bulkSelectionState.isAllSelected,
          isIndeterminate: bulkSelectionState.isIndeterminate,
        }}
        onSetGetSelectedData={(callback) => setGetSelectedStocksData(() => callback)}
      />
      
      {/* AddToPortfolioDialog managed by global provider */}
    </div>
  );
}

export default StocksRawExplorer;
